export const NO_ACTIVITY_TIMEOUT_MS = 60 * 1000;
export const NO_ACTIVITY_THROTTLE_MS = 5 * 1000;
export const PAGE_HIDDEN_THROTTLE_MS = 5 * 1000;
export const PAGE_HIDDEN_TIMEOUT_MS = 60 * 1000;
export const IMS_KEEP_ALIVE_INTERVAL_MS = 60 * 1000;
